import React from "react";
import { Button, ButtonProps, Text, useToken } from "@chakra-ui/react";

interface Props extends ButtonProps {
  isSelected?: boolean;
}

function SettlementButton({ isSelected, children, ...props }: Props) {
  const [baseBoxShadow, hairlineHover, hairlineActive] = useToken("shadows", [
    "baseBoxShadow",
    "hairlineHover",
    "hairlineActive",
  ]);

  const boxShadow = `0 0 0 ${
    isSelected ? "1px #1272EF" : "0.5px #8F8F8C"
  }, ${baseBoxShadow}`;

  const hoverStyle = isSelected
    ? { background: "#FCFCFB" }
    : {
        color: "#1272EF",
        boxShadow: `${hairlineHover}, ${baseBoxShadow}`,
      };

  const activeStyle = isSelected
    ? { background: "#FCFCFB" }
    : {
        color: "#00417D",
        boxShadow: `${hairlineActive}, ${baseBoxShadow}`,
      };

  return (
    <Button
      padding={"4px 8px"}
      color={"#444444"}
      borderRadius={"4px"}
      background={"#FCFCFB"}
      height={"28px"}
      boxShadow={boxShadow}
      _hover={hoverStyle}
      _active={activeStyle}
      {...props}
    >
      <Text textStyle={"body-sm-bold"}>{children}</Text>
    </Button>
  );
}

export default SettlementButton;
